import { PersonPictureDto, PersonPhysicalFeatureDto, PersonDto, ClientResources } from '@app/api2/api';
import * as Yup from 'yup';

export type PhysicalTypeMembers = Pick<PersonDto, 'id' | 'eyeColorId' | 'hairColorId' | 'heightInM' | 'weightInKg' | 'pictures' | 'physicalFeatures'>;

export const PhysicalSchema: (t: ClientResources) => Yup.SchemaOf<PhysicalTypeMembers> = (t) => Yup.object({
    id: Yup.number().optional().nullable().meta({ search: false }),
    eyeColorId: Yup.number().optional().nullable().label(t.metadata.eyeColorLabel || 'Eye Color'),
    hairColorId: Yup.number().optional().nullable().label(t.metadata.hairColorLabel || 'Hair Color'),
    heightInM: Yup.number().optional().nullable().label(t.metadata.heightLabel || 'Height (m)'),
    weightInKg: Yup.number().optional().nullable().label(t.metadata.weightLabel || 'Weight (kg)'),
    pictures: Yup.array().of(
        Yup.object().shape({
            id: Yup.number().optional().nullable(),
            fileName: Yup.string().max(100).required().label(t.metadata.fileNameLabel || 'File Name'),
            contentType: Yup.string().max(50).required().label(t.metadata.contentTypeLabel || 'Content Type'),
            // base64DataUrl: Yup.string().required('Image Data is required'),
            content: Yup.string().optional().nullable().label(t.metadata.contentLabel || 'Content'),
        }) as Yup.SchemaOf<PersonPictureDto>
    ).label(t.metadata.picturesLabel || 'Pictures').max(3, t.metadata.maximumPicturesAllowed || 'Maximum 3 pictures allowed').meta({ search: false }),
    physicalFeatures: Yup.array().of(
        Yup.object({
            id: Yup.number().optional().nullable().meta({ search: false }),
            featureTypeId: Yup.number().required().label(t.metadata.featureTypeLabel || 'Feature Type'),
            description: Yup.string().max(500).required().label(t.metadata.descriptionLabel || 'Description'),
        }) as Yup.SchemaOf<PersonPhysicalFeatureDto>
    ).label(t.metadata.physicalFeaturesLabel || 'Physical Features'),
});


type PhysicalTypeMembersObject = Record<(keyof PhysicalTypeMembers), undefined>;

const physicalDefProperties: PhysicalTypeMembersObject = {
    id: undefined,
    eyeColorId: undefined,
    hairColorId: undefined,
    heightInM: undefined,
    weightInKg: undefined,
    pictures: undefined,
    physicalFeatures: undefined,
};

export const ALL_PHYSICAL_PROPERTIES = Object.keys(physicalDefProperties) as (keyof PhysicalTypeMembers)[];
